module.exports = __webpack_public_path__ + "static/bfit1000-9b703e3280307d3c23112f9f8aaf72a7.png";